import { Query } from 'utility-ts-orm';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ISchedulerAvailableTermDatasource } from '../../scheduler_active_term/datasource/scheduler_available_terms_datasource';
import { ISchedulerAvailableTerm } from '../interfaces/scheduler_available_term';

export class SchedulerAvailableTermsQuery implements IQuery {
  get result() {
    return this._result;
  }

  private _result: {
    terms: ISchedulerAvailableTerm[];
    isEmpty: boolean;
  } = {
    terms: [],
    isEmpty: true
  };
  constructor(private ngSchedulerAvailableTermDatasource: ISchedulerAvailableTermDatasource) {
    Query.registerQuery(this, this.ngSchedulerAvailableTermDatasource);
  }

  run() {
    const terms = this.ngSchedulerAvailableTermDatasource.values();
    const termsSortedByStartDate = _4.sortBy(terms, 'term_start_dt');

    this._result = {
      isEmpty: _4.isEmpty(termsSortedByStartDate),
      terms: termsSortedByStartDate
    };
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngSchedulerAvailableTermsQuery', SchedulerAvailableTermsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/queries/scheduler_available_terms_query.ts